// 邮件发送类型
export enum EmailSendType {
  // 测试
  Test = '1',
  // 正式
  Official = '2',
}

// 邮件发送结果
export enum EmailSendResultStatus {
  // 全部成功
  Success = '1',
  // 部分成功，部分失败
  Partial = '2',
  // 全部失败
  Failed = '3',
}
